import './App.css';
import Dashboard from '../Dashboard/Dashboard';
import Login from '../Login/Login';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute from '../PrivateRoute/PrivateRoute';
import Register from '../Register';
import NavBar from '../NavBar';
import Contracts from '../Contracts';
import Requests from '../Requests';
import Request from '../Requests/Request';
import Contract from '../Contracts/Contract';
import Users from '../Users';
import '../../fonts/calibri-regular.ttf';
import User from '../Users/User';
import Report from '../Report';

function App() {
  return (
    <div className='App'>
      <NavBar />
      <Routes>
        <Route path='/' element={<Login />} />
        <Route path='/login' element={<Login />} />
        <Route path='/register' element={<Register />} />
        <Route
          path='/dashboard'
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path='/request'
          element={
            <PrivateRoute>
              <Request />
            </PrivateRoute>
          }
        />
        <Route
          path='/contracts'
          element={
            <PrivateRoute>
              <Contracts />
            </PrivateRoute>
          }
        />
        <Route
          path='/requests'
          element={
            <PrivateRoute>
              <Requests />
            </PrivateRoute>
          }
        />
        <Route
          path='/users'
          element={
            <PrivateRoute onlyAdmin>
              <Users />
            </PrivateRoute>
          }
        />
        <Route
          path='/report'
          element={
            <PrivateRoute onlyAdmin>
              <Report />
            </PrivateRoute>
          }
        />
        <Route
          path='/user'
          element={
            <PrivateRoute onlyAdmin>
              <User />
            </PrivateRoute>
          }
        />
        <Route
          path='/contract'
          element={
            <PrivateRoute>
              <Contract />
            </PrivateRoute>
          }
        />
      </Routes>
    </div>
  )
}

export default App;
